import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Popover } from "antd";
import { useMemo } from "react";

const MultipleConfirmation = ({
  btnTitle = "button",
  data = null,
  step,
  setStep,
  open,
  setOpen,
  btnClass = "bg-[#D2D2D2] text-black hover:bg-[#dedede] active:bg-[#ababab]",
  icon = <DeleteOutlined />,
  isDisabled = false,
}) => {
  const renderContentPopover = useMemo(() => {
    if (!step || !data) return;
    let dataContent = data[step?.step - 1];

    return (
      <div>
        {dataContent.title}
        <p className="">{dataContent.description}</p>
        {dataContent.footer && dataContent.footer}
        <div
          className="absolute top-1 right-1  p-1 px-2 hover:bg-[#dedede]/50 rounded-md cursor-pointer"
          onClick={() => {
            setOpen(false);
            setStep(null);
          }}
        >
          <CloseOutlined />
        </div>
      </div>
    );
  }, [step, data, setStep, setOpen]);

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
    if (!newOpen) {
      setStep(null);
    }
  };
  return (
    <>
      <Popover
        content={renderContentPopover}
        trigger="click"
        open={open}
        onOpenChange={handleOpenChange}
      >
        <Button
          type="primary"
          icon={icon}
          className={btnClass}
          onClick={() => {
            setOpen(true);
            setStep({
              step: 1,
              for_all_admin: false,
            });
          }}
          disabled={isDisabled}
        >
          {btnTitle}
        </Button>
      </Popover>
    </>
  );
};

export default MultipleConfirmation;
